export class ToolIDEnum {
	static readonly AHUB: string = "AHUB";
	static readonly AVIEW: string = "AVIEW";
	static readonly AVIEW_PRO: string = "AVIEW_PRO";
}
